import { withInstall } from '@vuemap/vue-amap-util'
import DefaultLayer from './DefaultLayer.vue'

export const ElAmapLayerDefault = withInstall(DefaultLayer)
export default ElAmapLayerDefault
